import { MessageCircle } from "lucide-react";
import wazeIcon from "@/assets/waze.png";

export const WhatsAppButton = () => (
  <div className="fixed bottom-20 left-4 sm:bottom-24 sm:left-6 z-40 flex flex-col gap-3">
    <a
      href="https://ul.waze.com/ul?venue_id=22872386.228920465.569051&overview=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="נווט אלינו עם Waze"
      className="md:hidden w-12 h-12 sm:w-14 sm:h-14 rounded-full overflow-hidden shadow-elegant hover:scale-110 transition-smooth bg-white"
    >
      <img src={wazeIcon} alt="" className="w-full h-full object-cover" />
    </a>
    <a
      href="https://wa.me/972505380626?text=שלום,%20אשמח%20לייעוץ%20משפטי"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="צור קשר בוואטסאפ"
      className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-elegant hover:scale-110 transition-smooth animate-soft-pulse"
    >
      <MessageCircle className="w-6 h-6 sm:w-7 sm:h-7 fill-current" />
    </a>
  </div>
);
